import { extendTheme } from '@chakra-ui/react';

/** Brand gradients: Ocean #0041FF→#167FFC | Violet #6C3BFF→#5100E0 | Magenta #E6007E→#FF00C1 | Tech #0041FF→#6C3BFF→#E6007E */
const theme = extendTheme({
  colors: {
    brand: {
      50: '#E8EEFF',
      100: '#C7D7FF',
      200: '#9BB5FF',
      300: '#6C3BFF',
      400: '#167FFC',
      500: '#0041FF',
      600: '#5100E0',
      700: '#3D00A8',
      800: '#2B0078',
      900: '#1a0047',
    },
    accent: {
      500: '#E6007E',
      600: '#FF00C1',
    },
    /* Override Chakra red to use brand palette - all colorScheme="red" now shows brand colors */
    red: {
      50: '#E8EEFF',
      100: '#C7D7FF',
      200: '#9BB5FF',
      300: '#6C3BFF',
      400: '#167FFC',
      500: '#0041FF',
      600: '#5100E0',
      700: '#3D00A8',
      800: '#2B0078',
      900: '#1a0047',
    },
  },
  components: {
    Button: {
      variants: {
        gradient: {
          bgGradient: 'linear(to-r, #0041FF, #6C3BFF, #E6007E)',
          color: 'white',
          _hover: {
            bgGradient: 'linear(to-r, #167FFC, #6C3BFF, #FF00C1)',
            _disabled: {
              bgGradient: 'linear(to-r, #0041FF, #6C3BFF, #E6007E)',
            },
          },
        },
        gradientOcean: {
          bgGradient: 'linear(to-r, #0041FF, #167FFC)',
          color: 'white',
          _hover: { opacity: 0.92 },
        },
        gradientMagenta: {
          bgGradient: 'linear(to-r, #E6007E, #FF00C1)',
          color: 'white',
          _hover: { opacity: 0.92 },
        },
      },
    },
  },
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
});

export default theme;
